import { RECEIVE_USER, ADD_FAVOURITE, REMOVE_FAVOURITE } from './../actions/UserAction';

const defaultState = {
    id        : null,
    favourites: []
};

const user = (state = defaultState, action) => {
    switch(action.type)
    {
        case RECEIVE_USER:
        case ADD_FAVOURITE:
        case REMOVE_FAVOURITE:
            return {...state, ...action.user};
        default:
            return state;
    }
};

export default user;


// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js